import ThisModule from "./StepDaysOfWeek";

export default ThisModule;
